
import { CameraOutlined, SendOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

export function InstaDMLayout({
  avatar,
  username,
  children,
  footer = true
}) {

  return <div className="hide-scrollbar" style={{
    width: '280px',
    height: '580px',
    maxHeight: "80%",
    border: '1px solid #ccc',
    borderRadius: '30px',
    overflow: 'scroll',
    overflowX: "hidden",
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    margin: '0 auto',
    position: 'relative',
    backgroundColor: "black",
    color: "white",
    paddingBottom: "20px",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "10px"
  }}>

    <div style={{
      width: "100%",
      height: 50,
      display: "flex",
      alignItems: "center",
      padding: "0 12px",
      borderTopLeftRadius: "30px",
      borderTopRightRadius: "30px",
      background: "rgba(0,0,0,0.85)",
      borderBottom: "1px solid #222",
      boxSizing: "border-box",
      zIndex: 10,
      marginTop: "0px",
      position: "sticky",
      top: 0,
      paddingTop: "6px"
    }}>
      {/* Profile Image */}
      <img
        src={avatar || "https://ui-avatars.com/api/?name=Buying+Customer"}
        alt="Profile"
        style={{
          width: 30,
          height: 30,
          borderRadius: "50%",
          objectFit: "cover",
          border: "2px solid #fff",
          marginRight: 10
        }}
      />
      {/* Name and status */}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: 13, color: "#fff" }}>
          {username || "Buying Customer"}
        </div>
        <div style={{ fontSize: 10, color: "#bdbdbd" }}>Instagram • Active now</div>
      </div>
      {/* Icons */}
      <div style={{ display: "flex", gap: 12 }}>
        {/* Call Icon */}
        <svg width="18" height="18" fill="#fff" style={{ cursor: "pointer" }} viewBox="0 0 24 24"><path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z" /></svg>
        {/* Video Icon */}
        <svg width="18" height="18" fill="#fff" style={{ cursor: "pointer" }} viewBox="0 0 24 24"><path d="M17 10.5V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-3.5l4 4v-11l-4 4z" /></svg>
        {/* Hamburger Icon */}
        <svg width="18" height="18" fill="#fff" style={{ cursor: "pointer" }} viewBox="0 0 24 24"><rect y="4" width="24" height="2" /><rect y="11" width="24" height="2" /><rect y="18" width="24" height="2" /></svg>
      </div>
    </div>

    <div style={{ padding: "12px 0", display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "end", flex: 1 }}>{children}</div>

    <div
      style={{
        position: "stickey",
        left: 0,
        right: 0,
        bottom: "-24px",
        width: "100%",
        background: "rgba(0,0,0,0.92)",
        borderBottomLeftRadius: "30px",
        borderBottomRightRadius: "30px",
        borderTop: "1px solid #222",
        padding: "10px 14px 14px 14px",
        display: "flex",
        alignItems: "center",
        zIndex: 2,
        gap: 8,
        paddingRight: "16px"
      }}
    >
      <CameraOutlined style={{ fontSize: "16px" }} />
      {/* Disabled Input */}
      <input
        type="text"
        disabled
        placeholder="Message..."
        style={{
          // flex: 1,
          background: "#18191a",
          border: "none",
          borderRadius: 18,
          padding: "8px 12px",
          color: "#bdbdbd",
          fontSize: 13,
          outline: "none",
          margin: "0 6px",
          opacity: 0.7,
          cursor: "not-allowed"
        }}
      />

      <svg width="24" height="24" fill="#bdbdbd" style={{ cursor: "pointer" }} viewBox="0 0 24 24">
        <path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3zm5-3a1 1 0 0 1 2 0 7 7 0 0 1-14 0 1 1 0 0 1 2 0 5 5 0 0 0 10 0zm-5 7a1 1 0 0 1-1-1v-1h2v1a1 1 0 0 1-1 1z" />
      </svg>
      <SendOutlined style={{ fontSize: "18px" }} />
    </div>
  </div>

}


export function InstagramStoryLayout({ igData, data }) {
  const triggerWords = data?.auto_reply?.triger_words || ["Reply to story..."];
  const [triggerIndex, settriggerIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (triggerWords.length < 1) return;

    const currentWord = triggerWords[triggerIndex];
    let charIndex = 0;

    // Reset and start typing
    setDisplayedText("");
    setIsTyping(true);

    // Typing effect
    const typingInterval = setInterval(() => {
      if (charIndex < currentWord?.length) {
        setDisplayedText(currentWord.substring(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typingInterval);
        setIsTyping(false);

        // Wait before moving to next word
        if (triggerWords.length > 1) {
          setTimeout(() => {
            settriggerIndex((prevIndex) => (prevIndex + 1) % triggerWords.length);
          }, 2000);
        }
      }
    }, 100); // Type one character every 100ms

    return () => clearInterval(typingInterval);
  }, [triggerIndex, triggerWords]);

  return (
    <div style={{
      width: '280px',
      height: '580px',
      maxHeight: "80%",
      border: '1px solid #ccc',
      borderRadius: '30px',
      overflow: 'hidden',
      boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
      margin: '0 auto',
      position: 'relative',
      backgroundColor: 'black',
      backgroundImage: `url("${igData?.media_url || igData?.thumbnail_url}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      {/* Top gradient overlay */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "120px",
        background: "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%)",
        zIndex: 1,
        borderRadius: "30px 30px 0 0"
      }} />

      {/* Story header */}
      <div style={{
        position: "absolute",
        top: 20,
        left: 16,
        right: 16,
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        gap: 10
      }}>
        {/* Progress bar */}
        <div style={{
          flex: 1,
          height: 3,
          background: "rgba(255,255,255,0.3)",
          borderRadius: 2,
          overflow: "hidden"
        }}>
          <div style={{
            width: "100%",
            height: "100%",
            background: "white",
            animation: "progress 5s linear infinite"
          }} />
        </div>
      </div>

      {/* Profile info */}
      <div style={{
        position: "absolute",
        top: 40,
        left: 12,
        right: 12,
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        gap: 8
      }}>
        <img
          src={data?.avatar || "https://ui-avatars.com/api/?name=You"}
          alt="Profile"
          style={{
            width: 26,
            height: 26,
            borderRadius: "50%",
            border: "1.5px solid white"
          }}
        />
        <span style={{ color: "white", fontWeight: 600, fontSize: 12 }}>
          {data?.username || "your_username"}
        </span>
        <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 10 }}>
          2h
        </span>
      </div>

      {/* Reply preview at bottom */}
      <div style={{
        position: "absolute",
        bottom: 30,
        left: 16,
        right: 16,
        zIndex: 2
      }}>
        <div style={{
          background: "rgba(0,0,0,0.6)",
          backdropFilter: "blur(10px)",
          borderRadius: 24,
          padding: "12px 16px",
          border: "1px solid rgba(255,255,255,0.2)",
          display: "flex",
          alignItems: "center",
          gap: 10
        }}>
          <img
            src="https://ui-avatars.com/api/?name=Viewer"
            alt="Viewer"
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              border: "1.5px solid white"
            }}
          />
          <div style={{ flex: 1 }}>
            <div style={{
              color: "white",
              fontSize: 12,
              margin: 0,
              display: "flex",
              alignItems: "center"
            }}>
              <span>{displayedText}</span>
              {isTyping && (
                <span style={{
                  display: "inline-block",
                  width: "2px",
                  height: "16px",
                  backgroundColor: "white",
                  marginLeft: "2px",
                  animation: "blink 0.8s infinite"
                }}>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Add animation keyframes */}
      <style>{`
        @keyframes progress {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }
        @keyframes blink {
          0%, 49% { opacity: 1; }
          50%, 100% { opacity: 0; }
        }
      `}</style>
    </div>
  );
}

export function InstagramCommentLayout({ igData, data }) {

  const triggerWords = data?.auto_reply?.triger_words || [];
  const replyComments = data?.auto_reply?.reply_comments || [];

  //   console.log("triggerWords-=-=" , triggerWords, replyComments)

  const [triggerIndex, settriggerIndex] = useState(0);
  const [indexReply, setReplyIndex] = useState(0);
  const [showReply, setShowReply] = useState(false);
  const [showComment, setShowComment] = useState(false);

  useEffect(() => {

    if (triggerWords.length < 2) {
      return
    }
    const interval = setInterval(() => {
      setShowComment(prev => {
        if (prev) {
          settriggerIndex(prevIndex => (prevIndex + 1) % triggerWords.length);
        }
        return !prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [triggerWords.length]);


  useEffect(() => {
    if (replyComments.length < 2) {
      return
    }
    const interval = setInterval(() => {
      setShowReply(prev => {
        if (prev) {
          setReplyIndex(prevIndex => (prevIndex + 1) % replyComments.length);
        }
        return !prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [replyComments.length]);

  return <div style={{
    width: '280px',
    height: '580px',
    maxHeight: "80%",
    border: '1px solid #ccc',
    borderRadius: '30px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    margin: '0 auto',
    position: 'relative', // IMPORTANT: for stacking
    backgroundColor: 'grey',
    backgroundImage: `url("${igData?.thumbnail_url}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}>
    {/* Overlay */}
    <div style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      background: "black",
      opacity: 0.6,
      zIndex: 1, // below the content
      borderRadius: "30px",
      pointerEvents: "none"
    }} />


    <div style={{
      position: 'absolute',
      zIndex: 2, // above the overlay
      borderRadius: "30px 30px 0 0",
      minHeight: "280px",
      width: "100%",
      backgroundColor: "black",
      overflowY: "auto",
      bottom: 0
    }}>
      <p style={{ textAlign: "center", fontSize: 14, fontWeight: "bold", color: "white", margin: "16px 0px" }}>
        Comments
      </p>

      <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 12,
        padding: "16px 10px"
      }}>
        <img
          src={data?.avatar || "https://ui-avatars.com/api/?name=Buying+Customer"}
          alt="Insta user"
          style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            objectFit: "cover",
            border: "1.5px solid #eee"
          }}
        />
        <div style={{ flex: 1 }}>
          {/* Username */}
          <p style={{ fontWeight: 600, margin: 0, fontSize: 11, color: "white" }}>
            {data?.username || "Buying Customer"}
          </p>
          {/* Comment */}
          <div style={{
            borderRadius: 12,
            padding: "0",
            margin: "6px 0",
            fontSize: 13,
            color: "white",
            display: "inline-block",
            maxWidth: "90%"
          }}>
            {/* {data?.auto_reply?.triger_words?.[0] || "Any comment"} */}
            <div className="bubble-text">{triggerWords[triggerIndex]}</div>
          </div>
        </div>
      </div>

      {(data?.auto_reply?.reply_comments?.[0] && data?.auto_reply?.enable_comment_reply == true) && <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 12,
        padding: "16px 50px"
      }}>
        <img
          src={data?.avatar || "https://ui-avatars.com/api/?name=You"}
          alt="Insta user"
          style={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            objectFit: "cover",
            border: "1.5px solid #eee"
          }}
        />
        <div style={{ flex: 1 }}>
          {/* Username */}
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, color: "white" }}>
            {data?.username || "You"}
          </p>
          {/* Comment */}
          <div style={{
            borderRadius: 12,
            padding: "0",
            margin: "6px 0",
            fontSize: 12,
            color: "white",
            display: "inline-block",
            maxWidth: "90%"
          }}>
            <div className="bubble-text"><p>{replyComments[indexReply]}</p></div>
          </div>
        </div>
      </div>}

    </div>
  </div>

}